import { getStoreId } from "$/hooks/use-store-information"
import selfBillingInvoiceQueries from "$/lib/queries/self-billing-invoice-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/bikes-for-sale/invoices")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId)
      queryClient.prefetchQuery(selfBillingInvoiceQueries.list(storeId))
    return { crumb: "alfred.pages.bikesForSale.crumbs.invoices" }
  },
})
